export const referenceSchema = {
  type: "object",
  fields: [
    {
      name: "type",
      type: "string",
      initialValue: "partner",
      options: {
        list: [
          { title: "Free form", value: "free" },
          { title: "Partner", value: "partner" },
        ],
        layout: "radio",
        direction: "horizontal",
      },
    },
    {
      name: "lead",
      type: "string",
    },
    {
      name: "title",
      type: "string",
    },
    {
      name: "text",
      type: "string",
      hidden: ({ parent }: any) => parent?.type !== "free",
    },
    {
      name: "url",
      type: "url",
      hidden: ({ parent }: any) => parent?.type !== "free",
    },
    {
      name: "image",
      type: "image",
      hidden: ({ parent }: any) => parent?.type !== "free",
    },
    {
      name: "partner",
      type: "reference",
      to: [{ type: "partner" }],
      hidden: ({ parent }: any) => parent?.type !== "partner",
    },
  ],
};

export const referenceGroq = `
  lead,
  title,
  text,
  "url": select(
    type == "free" => url,
    type == "partner" => partner->url
  ),
  "image": select(
    type == "free" => image,
    type == "partner" => partner->avatar
  )
`;
